/**
 * 共通通知サービス
 * 後で MatSnackBar 等に差し替えしやすい形
 */

import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

/** 通知レベル */
export type NotificationLevel = 'success' | 'error' | 'info';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(private readonly snackBar: MatSnackBar) {}

  showSuccess(message: string): void {
    this.show(message, 'success');
  }

  showError(message: string): void {
    this.show(message, 'error');
  }

  showInfo(message: string): void {
    this.show(message, 'info');
  }

  private show(message: string, level: NotificationLevel): void {
    const duration = level === 'error' ? 5000 : 3000;
    const panelClass = level === 'success'
      ? ['snackbar-success']
      : level === 'error'
        ? ['snackbar-error']
        : [];

    this.snackBar.open(message, '閉じる', { duration, panelClass });
  }
}
